import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import * as models from '../model';
import { environment } from '../../../../environments/environment';
import { LandingPageMapper } from '../mappers';

@Injectable()
export class LandingPageApi {
  protected basePath = `${environment.API_V4}/admin/landing-pages`;

  constructor(protected http: HttpClient) {}

  /**
   * @summary Create a new instance of the model and persist it into the data source.
   * @param data Model instance data
   */
  public create(data: models.LandingPage): Observable<models.LandingPage> {
    return this.http.post<models.LandingPage>(this.basePath, data);
  }

  /**
   * @summary Find all instances of the model matched by filter from the data source.
   */
  public find(): Observable<Array<models.LandingPage>> {
    return this.http.get<Array<models.LandingPage>>(this.basePath).pipe(map((items) => LandingPageMapper.mapItems(items)));
  }

  /**
   * @summary Find a model instance by {{id}} from the data source.
   * @param id Model id
   */
  public findById(id: string): Observable<models.LandingPage> {
    const path = `${this.basePath}/${id}`;
    // verify required parameter 'id' is not null or undefined
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling findById.'
      );
    }
    return this.http.get<models.LandingPage>(path).pipe(map((item) => LandingPageMapper.mapItem(item)));
  }

  /**
   * @summary Patch an existing model instance or insert a new one into the data source.
   * @param id Model id
   * @param data Model instance data
   */
  public updateById(
    id: string,
    data: models.LandingPage
  ): Observable<void> {
    const path = `${this.basePath}/${id}`;
    // verify required parameter 'id' is not null or undefined
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling updateById.'
      );
    }
    return this.http.patch<void>(path, data);
  }

  /**
   * @summary Delete a model instance by {{id}} from the data source.
   * @param id Model id
   */
  public deleteById(id: string): Observable<void> {
    const path = `${this.basePath}/${id}`;
    // verify required parameter 'id' is not null or undefined
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling deleteById.'
      );
    }
    return this.http.delete<void>(path);
  }
}
